export default __webpack_public_path__ + "static/media/home-restaurant-img-19.6c64b4f4.jpg";